// @flow
import * as React from "react";

import AutoComplete from "views/UI/material-ui/AutoComplete";

import useDataSource from "./useDataSource";

type Props = { ... };

function AffiliateAutoComplete(props: Props): React.Node {
  const dataSource = useDataSource();

  return <AutoComplete {...props} dataSource={dataSource} />;
}

export default AffiliateAutoComplete;
